import { useContext, useEffect, useState } from "react"
import { GlobalContext } from "../GlobalContext"
import Spinner from "../ui-elements/Spinner"
import YellowAlert from "../ui-elements/YellowAlert"
import Button from "../formfields/Button"
import FormatQuestionTitle from "../dashboard/FormatQuestionTitle"
import CloudformationOutputs from "../CloudformationOutputs.json"
import Modal from "../ui-elements/Modal"
import FormatQuestionAnswer from "../dashboard/FormatQuestionAnswer"


type Props = {
    AiAnswer: ObjectStringKeyAnyValue
    setQuestionAnswerValue: React.Dispatch<React.SetStateAction<any>>
    questionAnswerValue: any,
    setShowAiAnswerModal: React.Dispatch<React.SetStateAction<boolean>>
    validate: AnyFunction
    thisQuestion: ObjectStringKeyAnyValue
}

function AiAnswer({
    AiAnswer,
    setQuestionAnswerValue,
    validate,
    setShowAiAnswerModal,
    thisQuestion,
    questionAnswerValue
}: Props) {
    

    const [readyToSave, setReadyToSave] = useState(false);

    

    const {
        tableData,
        currentOrganisation
    } = useContext(GlobalContext)

    useEffect(() => {
        // console.log(`Question answer value or ready to save changed:`, questionAnswerValue, readyToSave)
        if(questionAnswerValue && readyToSave) {
            console.log("Ready to save AI answer", questionAnswerValue)
            validate({ behaviour: 'save' })
            setShowAiAnswerModal(false)
        }
    }, [readyToSave, questionAnswerValue])

    const acceptAnswerSave = () => {
        setReadyToSave(true)
        setQuestionAnswerValue(aiAnswerToAccept)
        // console.log("Accepting AI answer", aiAnswerToAccept)
    }
    if (!AiAnswer) {
        return null
    }

    const originalAnswerId: string = AiAnswer['originalAnswerId']
    const originalQuestionId: string = AiAnswer['originalQuestionId']
    const originalAnswerHasBeenAnswered = originalAnswerId && tableData && tableData['ChecklistAnswers'] && tableData['ChecklistAnswers'][originalAnswerId] && tableData['ChecklistAnswers'][originalAnswerId]['Pending'] === false
    const originalAnswer = originalAnswerId && tableData && tableData['ChecklistAnswers'] && tableData['ChecklistAnswers'][originalAnswerId]
    const originalQuestion = originalQuestionId && tableData && tableData['ChecklistQuestions'] && tableData['ChecklistQuestions'][originalQuestionId]
    const originalAnswerImage = originalAnswer && originalAnswer['ImageFileName']
    let aiAnswerToAccept = AiAnswer['status'] === 'completed' && !AiAnswer['error'] && AiAnswer['answerFromAi']


    if (!originalAnswerHasBeenAnswered) {
        return <><YellowAlert>The photo is not yet available for AI to begin processing</YellowAlert>
            <br/>
        </>
    }



    return <Modal>
        <div className={`flex flex-col gap-4 items-center justify-center w-full`}>

            {thisQuestion && <FormatQuestionTitle
                question={thisQuestion}
                classString={`font-righteous text-brandblue text-xl`}
            />}

            {originalAnswerImage && <img
                src={`https://${CloudformationOutputs.ImageBucketName}.s3.eu-west-1.amazonaws.com/${currentOrganisation}/${originalAnswerImage}`}
                alt="Original Answer"
                className={`rounded`}
                style={{ 
                    maxWidth: '80%', 
                    maxHeight: '80%'
                 }}

            />}
            <div className={`w-full flex flex-row gap-4 items-center`}>



                <div className={`w-full flex flex-col gap-2 justify-center items-center`}>

                    {originalQuestion && <div className={``}>
                        <p className={`text-xs`}>This question refers to a previous photo question:</p>
                        <FormatQuestionTitle
                            question={originalQuestion}
                            classString={`font-bold`}
                        />
                    </div>}

                    {AiAnswer['status'] === 'pending' && !AiAnswer['error'] && <Spinner alignment="center" size="small">Waiting for AI response...</Spinner>}

                    {AiAnswer['error'] && <YellowAlert alignment="left" fullwidth={true}> 🤖 AI error:  {AiAnswer['error']}</YellowAlert>}

                    {aiAnswerToAccept && <div className={`w-full flex flex-col gap-0 justify-center items-center`}>
                        <p className={`text-xs`}>🤖 AI suggested answer: </p>
          
                        <FormatQuestionAnswer
                            question={thisQuestion}
                            questionAnswer={{"Answer": aiAnswerToAccept}}
                        />
                    </div>}

                </div>
            </div>
            <div className={`w-full flex flex-row gap-2`}>
                {!AiAnswer['error'] && <Button
                    onClick={() => { setShowAiAnswerModal(false) }}
                    text={`Cancel`}
                    variant={`gray`}
                    fullwidth={true}
                    size="big"
                />}

                {AiAnswer['error'] && <Button
                    onClick={() => { setShowAiAnswerModal(false) }}
                    text={`Answer manually`}
                    variant={`primary`}
                    fullwidth={true}
                    size="big"
                />}
                

                {aiAnswerToAccept && <Button
                    onClick={acceptAnswerSave}
                    text={`Accept`}
                    variant={`primary`}
                    fullwidth={true}
                    size="big"
                />}
            </div>
        </div>
    </Modal>

}

export default AiAnswer